<div class="container">
  <app-two-column-form
    [assignedHeaderText]="CONSTANTS.ASSIGNED_GROUPS"
    [assignedData]="assignedGroupData"
    [availableHeaderText]="CONSTANTS.ALL_GROUPS"
    [availableData]="allGroups"
    (updateAssignedValues)="handleUpdateAssignedValues($event)"
  ></app-two-column-form>
</div>
